module.exports = __webpack_public_path__ + "img/118.89ec139d.jpg";